import { FeatureSwitchSettings } from '@/settings/feature-switch.settings';
import { OnboardingFeature } from '@/settings/feature-switch.settings';

export default function onboardingGuard({
  next,
  router,
}: {
  next: any;
  router: any;
}) {
  const featureSwitchSettings = new FeatureSwitchSettings();

  if (!featureSwitchSettings.isFeatureEnabled(OnboardingFeature)) {
    router.push({ path: '/' });
  }

  return next();
}
